import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
} from '@angular/core';
import { MinesBetSectionComponent } from './mines-bet-section/mines-bet-section.component';
import { MinesBoardComponent } from './mines-board/mines-board.component';
import { MinesService } from './mines.service';

@Component({
  selector: 'app-mines',
  templateUrl: './mines.component.html',
  styleUrls: ['./mines.component.scss'],
  standalone: true,
  imports: [MinesBetSectionComponent, MinesBoardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MinesComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly minesService = inject(MinesService);

  constructor() {
    this.destroyRef.onDestroy(() => {
      if (this.minesService.currentGame()?.status === 'finished') {
        this.minesService.resetBoard();
      }
    });
  }
}
